<script lang="ts">
    // Casca de uma tela em folha (bottom sheet no mobile): uma pilha de blocos que rola e uma barra
    // de ação que fica fixa no rodapé, sempre visível. É genérica de propósito — a agenda usa para
    // o agendamento e a ideia é o PDV usar para a venda.
    //
    // Espera ficar dentro de um contêiner com altura definida (é o caso do corpo do Popover, que é
    // uma coluna flex). O corpo rola; o rodapé nunca sai da tela.
    let className: string = ''
    export { className as class }
    // espaçamento interno do corpo (o rodapé tem o seu)
    export let padding: string = '12px'
</script>

<div class="zsheet {className}">
    <div class="zsheet_body scroll-dark" style="padding:{padding};">
        <slot />
    </div>
    {#if $$slots.footer}
        <div class="zsheet_footer">
            <slot name="footer" />
        </div>
    {/if}
</div>

<style>
    /* valores base = tema escuro (padrão do app, inclusive sem classe de tema no body) */
    .zsheet {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        /* sem isto o corpo não rola: um filho flex tem min-height auto e estica o pai */
        min-height: 0;
        height: 100%;
        background: #1c1c1c;
    }
    .zsheet_body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        gap: 12px;
        /* nada de -webkit-overflow-scrolling: touch aqui. Do iOS 13 em diante o momentum já é o
           padrão, então a propriedade não acrescenta nada — mas ela ainda joga o scroller numa
           camada de composição própria no WebKit, e um position:fixed dentro dela (a lista de tela
           cheia do ZinputExpander) pode não ser pintado até um zoom ou uma rolagem forçar a
           recomposição. Era o relato de "a lista não aparece até dar zoom" no iPhone. */
        /* quando algo rola para dentro da tela sozinho (um campo que recebeu foco, um bloco que
           abriu), o navegador para assim que ele encosta na borda — e encostar aqui é ficar colado
           no rodapé fixo. Estas duas regras garantem a folga: uma para a rolagem automática, a
           outra é um vão real no fim da lista, para o último bloco também subir acima do rodapé. */
        scroll-padding-bottom: var(--zsheet-gap, 28px);
    }
    .zsheet_body::after {
        content: '';
        flex: 0 0 var(--zsheet-gap, 28px);
    }
    .zsheet_footer {
        flex: 0 0 auto;
        padding: 10px 12px;
        /* respeita a faixa do gesto de voltar do iPhone */
        padding-bottom: calc(10px + env(safe-area-inset-bottom, 0px));
        border-top: 1px solid #ffffff14;
        background: #202020;
    }

    :global(.theme_light) .zsheet {
        background: #f2f3f5;
    }
    :global(.theme_light) .zsheet_footer {
        border-top-color: #e2e4e8;
        background: #ffffff;
    }
</style>
